class MegaMenuEnhancements {
  constructor(menu) {
    this.menu = menu;
    this.panel = menu.querySelector('.dropdown-content');
    this.trigger = menu.querySelector('.dropbtn a');

    if (!this.panel || !this.trigger) return;

    this.panel.id ||= `MegaMenuPanel-${Math.random().toString(36).slice(2, 9)}`;
    this.menu.megaMenuEnhancement = this;
    this.overlay = getMegaMenuOverlay();
    this.isClickPinned = false;
    this.trigger.setAttribute('aria-haspopup', 'true');
    this.trigger.setAttribute('aria-controls', this.panel.id);
    this.setOpen(false);

    menu.addEventListener('mouseenter', () => {
      this.cancelClose();
      this.setOpen(true);
    });
    menu.addEventListener('mouseleave', () => this.scheduleClose());
    this.panel.addEventListener('mouseenter', () => this.cancelClose());
    this.panel.addEventListener('mouseleave', () => this.scheduleClose());
    menu.addEventListener('focusin', () => {
      this.cancelClose();
      this.setOpen(true);
    });
    this.trigger.addEventListener('click', (event) => {
      if (window.matchMedia('(max-width: 990px)').matches) return;

      event.preventDefault();
      this.cancelClose();

      if (this.isClickPinned) {
        this.setOpen(false);
        return;
      }

      this.isClickPinned = true;
      this.setOpen(true);
    });
    menu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!menu.contains(document.activeElement)) this.scheduleClose();
      });
    });
    menu.addEventListener('keydown', (event) => this.onKeydown(event));
  }

  setOpen(open, { suppressOverlayUpdate = false } = {}) {
    if (window.matchMedia('(max-width: 990px)').matches) return;

    if (!open) this.isClickPinned = false;

    if (open) {
      document.querySelectorAll('.mak-navbar .new-menu.mega-menu--open').forEach((menu) => {
        if (menu !== this.menu) {
          menu.megaMenuEnhancement?.cancelClose();
          menu.megaMenuEnhancement?.setOpen(false, { suppressOverlayUpdate: true });
        }
      });
    }

    this.menu.classList.toggle('mega-menu--open', open);
    this.trigger.setAttribute('aria-expanded', String(open));
    this.panel.toggleAttribute('inert', !open);
    if (!suppressOverlayUpdate) window.requestAnimationFrame(() => this.updateOverlay());
  }

  scheduleClose() {
    if (this.isClickPinned) return;

    this.cancelClose();
    this.closeTimer = window.setTimeout(() => this.setOpen(false), 450);
  }

  cancelClose() {
    window.clearTimeout(this.closeTimer);
  }

  updateOverlay() {
    syncMegaMenuOverlay(this.overlay);
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;

    this.cancelClose();
    this.setOpen(false);
    this.trigger.focus();
  }
}

let overlayHideTimer;

function syncMegaMenuOverlay(overlay) {
  const hasOpenMenu = document.querySelector('.mak-navbar .new-menu.mega-menu--open');
  window.clearTimeout(overlayHideTimer);

  if (hasOpenMenu) {
    overlay.hidden = false;
    window.requestAnimationFrame(() => overlay.classList.add('is-visible'));
    return;
  }

  overlay.classList.remove('is-visible');
  overlayHideTimer = window.setTimeout(() => {
    if (!document.querySelector('.mak-navbar .new-menu.mega-menu--open')) overlay.hidden = true;
  }, 300);
}

function getMegaMenuOverlay() {
  let overlay = document.querySelector('.mega-menu-overlay');
  if (overlay) return overlay;

  overlay = document.createElement('button');
  overlay.className = 'mega-menu-overlay';
  overlay.type = 'button';
  overlay.hidden = true;
  overlay.setAttribute('aria-label', 'Close navigation');
  overlay.addEventListener('click', () => {
    document.querySelectorAll('.mak-navbar .new-menu.mega-menu--open').forEach((menu) => menu.megaMenuEnhancement?.setOpen(false));
  });
  document.body.append(overlay);
  return overlay;
}

function setMegaMenuOffset() {
  const header = document.querySelector('.section-header');
  if (!header) return;

  document.documentElement.style.setProperty('--mega-menu-top', `${header.getBoundingClientRect().bottom}px`);
}

function initializeEditorialPanels() {
  document.querySelectorAll('.editorial-mega-menu').forEach((menu) => {
    const triggers = menu.querySelectorAll('[data-editorial-trigger]');
    const panels = menu.querySelectorAll('.editorial-mega-menu__panel');

    const showPanel = (id) => {
      const panel = menu.querySelector(`#${id}`);
      if (!panel || panel.classList.contains('is-active')) return;

      triggers.forEach((trigger) => trigger.classList.toggle('is-active', trigger.dataset.editorialTrigger === id));
      panels.forEach((item) => {
        const isActive = item === panel;
        item.hidden = !isActive;
        item.classList.toggle('is-active', isActive);
      });
      window.requestAnimationFrame(() => alignEditorialCtas(menu));
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('pointerenter', () => showPanel(trigger.dataset.editorialTrigger));
      trigger.addEventListener('focus', () => showPanel(trigger.dataset.editorialTrigger));
    });

    alignEditorialCtas(menu);
  });
}

function initializeMobileAnchorNavigation() {
  if (window.mobileAnchorNavigationInitialized) return;

  window.mobileAnchorNavigationInitialized = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mobile-menu-anchor-link]');
    if (!link || !window.matchMedia('(max-width: 990px)').matches) return;

    const drawer = link.closest('header-drawer');
    const summary = drawer?.querySelector('#Details-menu-drawer-container > summary');

    if (drawer?.closeMenuDrawer && summary) {
      drawer.closeMenuDrawer(event, summary);
      drawer.mainDetailsToggle.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
  });
}

function alignEditorialCtas(menu) {
  const activePanel = menu.querySelector('.editorial-mega-menu__panel.is-active:not([hidden])');
  if (!activePanel) return;

  const titles = [...activePanel.querySelectorAll('.editorial-mega-menu__title')];
  if (!titles.length) return;

  titles.forEach((title) => title.style.removeProperty('min-height'));
  const tallestTitle = Math.ceil(Math.max(...titles.map((title) => title.getBoundingClientRect().height)));
  titles.forEach((title) => {
    title.style.minHeight = `${tallestTitle}px`;
  });
}

function alignAllEditorialCtas() {
  document.querySelectorAll('.editorial-mega-menu').forEach(alignEditorialCtas);
}

function initializeMegaMenus() {
  document.querySelectorAll('.mak-navbar .new-menu').forEach((menu) => new MegaMenuEnhancements(menu));
  initializeEditorialPanels();
  initializeMobileAnchorNavigation();
  setMegaMenuOffset();
  window.addEventListener('resize', setMegaMenuOffset, { passive: true });
  window.addEventListener('resize', alignAllEditorialCtas, { passive: true });
  window.addEventListener('scroll', setMegaMenuOffset, { passive: true });
  document.fonts?.ready.then(alignAllEditorialCtas);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMegaMenus, { once: true });
} else {
  initializeMegaMenus();
}
